import React from 'react';

import { Outlet } from 'react-router-dom';
const EmployeeMngPage = () => {
  return (
    <Outlet />
  );
};

export default EmployeeMngPage;
